<template>
    <div>
        <base-table
            hide-default-footer
            v-bind="$attrs"
            v-on="$listeners"
            :headers="processedHeaders"
            :items="processedItems"
            :options="options"
            @click:row="onClickRowItem"
        >
            <template v-slot:[`item.${$constant.table.PARTICIPANT_KEY.registrationDate}`]="{ item }">
                <div>
                    {{ $util.getDDMMYYYYDateFormat(item[$constant.table.PARTICIPANT_KEY.registrationDate]) }}
                </div>
            </template>
        </base-table>
    </div>
</template>

<script>
import BaseTable from '@/components/tables/BaseTable'
import ExcludableTable from '@/mixins/ExcludableTable'

export default {
    name: 'ParticipantTable',

    components: {
        BaseTable
    },

    mixins: [ExcludableTable],

    props: {
        items: {
            type: Array,
            default: () => []
        },

        options: {
            type: Object,
            default: () => ({})
        }
    },

    data () {
        return {
            headers: [
                {
                    text: this.$t('participantList.table.header.name'),
                    value: this.$constant.table.PARTICIPANT_KEY.name,
                    sortable: false
                },
                {
                    text: this.$t('participantList.table.header.phone'),
                    value: this.$constant.table.PARTICIPANT_KEY.phone,
                    sortable: false
                },
                {
                    text: this.$t('participantList.table.header.customer'),
                    value: this.$constant.table.PARTICIPANT_KEY.customer,
                    sortable: false
                },
                {
                    text: this.$t('participantList.table.header.registrationDate'),
                    value: this.$constant.table.PARTICIPANT_KEY.registrationDate,
                    width: '160px'
                }
            ]
        }
    },

    computed: {
        processedItems () {
            return this.items.map((item) => ({
                ...item,
                name: item.contact.name,
                customerName: item.customer.name,
                contactPhone: item.contact.phone
            }))
        }
    },

    methods: {
        onClickRowItem (item) {
            this.$emit('viewDetails', item)
        }
    }
}
</script>

<style lang="scss" scoped></style>
